export default __webpack_public_path__ + "static/media/isle.07fbe0e0.svg";